import { LooseObjectType } from './globalTypes';

function sortQuestions<
  A extends LooseObjectType,
  Q extends { answerChoices?: A[] },
  // eslint-disable-next-line no-unused-vars
>(questions: Q[], getSortKey: (_item: Q | A) => number): Q[] {
  return [...questions]
    .sort((a, b) => getSortKey(a) - getSortKey(b))
    .map((q) => ({
      ...q,
      answerChoices: q.answerChoices
        ? [...q.answerChoices].sort((a, b) => getSortKey(a) - getSortKey(b))
        : q.answerChoices,
    }));
}

export default sortQuestions;
